<template>
  <section>
    <h1 class="text-h3 mb-8">
      Tabs
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <div class="d-flex justify-space-between">
        <v-checkbox
          v-model="centered"
          label="Centered"
        />
        <v-checkbox
          v-model="fixedTabs"
          label="Fixed tabs"
        />
        <v-checkbox
          v-model="hideSlider"
          label="Hide slider"
        />
      </div>
      <v-card>
        <v-tabs
          v-model="tab"
          :centered="centered"
          :fixed-tabs="fixedTabs"
          :grow="grow"
          :hide-slider="hideSlider"
        >
          <v-tab
            v-for="n in length"
            :key="n"
          >
            <v-icon left>
              fa-regular fa-music
            </v-icon>
            Tab {{ n }}
          </v-tab>
        </v-tabs>
      </v-card>
      <div class="text-center mt-4">
        <v-btn
          :disabled="!length"
          text
          @click="removeTab"
        >
          Remove Tab
        </v-btn>
        <v-divider
          class="mx-4"
          vertical
        />
        <v-btn
          text
          @click="addTab"
        >
          Add Tab
        </v-btn>
      </div>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/tabs/">
      <strong>Tabs</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsTabs',
  data: () => ({
    length: 3,
    tab: 2,
    centered: false,
    fixedTabs: false,
    hideSlider: false
  }),
  methods: {
    addTab () {
      this.tab = this.length++
    },
    removeTab () {
      this.length--
    }
  }
}
</script>
